export default __webpack_public_path__ + "images/remove-red-eye.png";